<template>
  <v-main>

    <v-container
        id="payments-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-bank-check"
          class="px-5 py-5"
      >

        <shared-page-messages :error-messages="errorMessages"
                              :warning-messages="warningMessages"
                              :success-messages="successMessages">
        </shared-page-messages>

        <v-row align="center" class="mt-5">
            <v-col
                cols="6"
                lg="3"
                sm="3"
            >
              <v-select
                  v-model="bulkActionStatus"
                  :items="computedPaymentStatusItems"
                  item-text="text"
                  item-value="value"
                  label="Bulk Status"
                  return-object
                  dense
                  hint="Apply to selected payments"
                  persistent-hint
              ></v-select>
            </v-col>

            <v-col
                cols="3"
                sm="3"
                lg="2"
            >
              <v-btn
                  small
                  color="primary"
                  @click="handleBulkActionForm"
              >
                Submit
              </v-btn>
            </v-col>
            <v-col
                cols="3"
                lg="7"
                sm="6"
                align="right"
            >

              <v-dialog
                v-model="filtersDialog"
                max-width="400"
              >

                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      @click="exportCsv"
                      color="primary"
                      small
                      class="float-right mx-0"
                  >
                    CSV Export
                  </v-btn>
                  <v-btn
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="float-right mx-2"
                  >
                    <v-icon size="small">mdi-filter</v-icon> Filters
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5 text-left">
                    Payment Filters
                  </v-card-title>

                  <v-card-text>

                    <v-form ref="paymentFiltersForm"
                            @submit.prevent="applyFilters">

                      <v-row dense>
                        <v-col
                            cols="12"
                        >
                          <v-combobox
                              v-model="filter.claim"
                              label="Claim"
                              placeholder="Start typing to search"
                              :items="computedClaimList"
                              :loading="isLoadingClaims"
                              :search-input.sync="claimSearchString"
                              @input.native="nativeClaimSearchString=$event.srcElement.value"
                              item-text="names"
                              item-value="id"
                              return-object
                              no-filter
                              persistent-placeholder
                              validate-on-blur
                              clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="12"
                        >
                         <v-select
                             v-model="filter.statuses"
                             :items="computedPaymentStatusItems"
                             label="Payment Status"
                             item-text="text"
                             item-value="value"
                             dense
                             multiple
                         ></v-select>
                        </v-col>

                      </v-row>
                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="12"
                        >
                          <v-select
                              v-model="filter.paymentMethod"
                              :items="computedPaymentMethodItems"
                              label="Payment Method"
                              item-text="text"
                              item-value="value"
                              dense
                          ></v-select>

                        </v-col>

                      </v-row>

                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="12"
                        >
                          <v-text-field
                              v-model="filter.referenceNumber"
                              label="Reference Number"
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="12"
                        >
                          <v-text-field
                              v-model="filter.firstName"
                              label="First Name"
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col
                            cols="12"
                            sm="12"
                        >
                          <v-text-field
                              v-model="filter.lastName"
                              label="Last Name"
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>


                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        color="primary"
                        @click="filtersDialog = false"
                        class="float-right mx-0"
                    >
                      Close
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        @click="applyFilters"
                        class="float-right mx-2"
                    >
                      Apply
                    </v-btn>
                    <v-btn
                        small
                        color="primary"
                        class="float-right mx-0"
                        @click="resetFilters"
                    >
                      Reset
                    </v-btn>
                  </v-card-actions>

                </v-card>

              </v-dialog>
            </v-col>
          </v-row>

          <v-simple-table v-if="computedPaymentsList" class="pt-5"
            dense
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="payment-action">
                  <v-checkbox
                      v-model="computedSelectAll"
                      hide-details
                      class="shrink ma-0 pa-0"
                  />
                </th>
                <th class="payment-invoice-num text-subtitle-2">Inv #</th>
                <th class="payment-date text-subtitle-2">Date</th>
                <th class="payment-from text-subtitle-2">From</th>
                <th class="payment-claim text-subtitle-2">Replenishment/Details</th>
                <th class="payment-amount text-right text-subtitle-2">Amount</th>
                <th class="payment-method text-subtitle-2">Method</th>
                <th class="payment-reference text-subtitle-2">Ref. #</th>
                <th class="payment-status text-subtitle-2">Status</th>
              </tr>
              </thead>

              <tbody>
              <tr
                  v-for="payment in searchResponse.content"
                  :key="payment.id"
              >
                <td>
                  <v-checkbox
                      v-model="bulkActionItems"
                      :value="payment.id"
                      hide-details
                      class="shrink ma-0 pa-0"
                  />
                </td>
                <td>
                  <router-link :to="{ name: 'view_invoice', params: {invoiceId: payment.invoice.id} }">
                    {{ payment.invoice.id }}
                  </router-link>
                </td>
                <td>{{ payment.date | formatLocalDate }} </td>
                <td>
                  {{ payment.invoice.user.names }}
                </td>
                <td>
                  {{ payment.invoice.items[0].description }}
                </td>
                <td class="text-right"> {{ payment.amount | formatCurrency }} </td>
                <td> {{ paymentMethodMap[payment.method] }} </td>
                <td>
                  <router-link :to="{ name: 'add_edit_payment', params: {invoiceId: payment.invoice.id, paymentId: payment.id} }">
                    ...{{ payment.reference.slice(-8) }}
                  </router-link>
                </td>
                <td>{{ paymentStatusMap[payment.status] }}</td>
              </tr>
              </tbody>

            </template>
          </v-simple-table>

        <div class="text-center mt-3">
          <v-row>
            <v-col class="page-counts text-body-2" cols="12">
              {{ computedPageStart }} - {{ computedPageEnd }} of {{ searchResponse.page.totalElements }}
            </v-col>
          </v-row>
          <v-pagination
              v-model="filter.page"
              :length="searchResponse.page.totalPages || 1"
              :total-visible="8"
              @input="fetchPayments"
          ></v-pagination>
        </div>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import exportUtils from '@/utils/export'
import SharedPageMessages from '../shared/PageMessages.vue'
import moment from 'moment-timezone'

export default {
  name: 'CorePaymentsView',
  components: { SharedPageMessages },

  created: async function () {
    await this.fetchPayments(1)
  },

  props: [
      'paymentStatuses'
  ],

  computed: {
    computedPaymentsList: function () {
      return this.searchResponse.content
    },

    computedPageStart: function () {
      const page = this.searchResponse.page
      if (page.totalElements === 0) {
        return 0
      }

      return (page.number * page.size) + 1
    },

    computedPageEnd: function () {
      const page = this.searchResponse.page
      if (page.totalElements === 0) {
        return 0
      }

      if (page.totalPages === 1) {
        return page.totalElements
      }
      return (page.number * page.size) + page.size
    },

    computedSelectAll: {
      set: function (value) {
        if (value === true) {
          this.searchResponse.content.forEach(payment => {
            this.bulkActionItems.push(payment.id)
          })
        }
      },
      get: function () {
        return this.computedPaymentsList.length > 0 && this.computedPaymentsList.length === this.bulkActionItems.length
      }
    },

    computedPaymentStatusItems: {
      get: function () {
        return Object.keys(this.paymentStatusMap)
            .map((key) => ({value: key, text: this.paymentStatusMap[key]}))
      }
    },

    computedPaymentMethodItems: {
      get: function () {
        return Object.keys(this.paymentMethodMap)
            .map((key) => ({value: key, text: this.paymentMethodMap[key]}))
      }
    },

    computedClaimList: {
      get() {
        return this.claims
            .map(claim => ({id: claim.id, names: `${claim.user.names} (${claim.dependent.names})`}))
      }
    },
  },

  watch: {
    claimSearchString(val) {
      if (!this.isLoadingClaims && val !== null && (val.length > 2)) {
        this.fetchClaims(val)
      }
    },
    searchResponse: function (val) {
      if (val.page.totalElements === 0) {
        this.warningMessages.push("No payments matching your filter criteria could be found. Please adjust your filters.")
      }
    },
    errorMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    successMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    warningMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    }
  },

  methods: {
    clearMessages: function() {
      this.errorMessages = []
      this.successMessages = []
      this.warningMessages = []
    },

    handleBulkActionForm: function () {
      this.clearMessages()
      this.successMessages = []
      if (this.bulkActionStatus === null) {
        this.errorMessages.push('Please select a bulk status')
      }

      if (this.bulkActionItems.length === 0) {
        this.errorMessages.push('Please select at least one payment')
      }

      if (this.errorMessages.length === 0) {
        this.processBulkAction()
      }
    },

    resetFilters: function () {
      this.filtersDialog = false
      this.filter = {
        claimId: null,
        referenceNumber: null,
        statuses: this.paymentStatuses,
        paymentMethods: [],
        firstName: null,
        lastName: null,
      }
      this.fetchPayments(1)
    },

    applyFilters: function () {
      this.filtersDialog = false
      this.clearMessages()
      this.fetchPayments(1)
    },

    async fetchPayments(page) {
      const response = await this.fetchFilteredPayments(this.filter, page)
      if (response) {
        this.searchResponse = response
      }
    },

    async fetchPaymentsForExport() {
      const exportFilter = { ...this.filter }
      exportFilter.itemsPerPage = 5000
      return await this.fetchFilteredPayments(exportFilter, 1)
    },

    fetchFilteredPayments: async function (filters, page) {
      this.clearMessages()
      this.isLoadingPayments = true
      filters.page = page || 1
      const claimId = filters.claim ? filters.claim.id : null

      let filterParams = {
        claimId: claimId,
        referenceNumber: filters.referenceNumber,
        statuses: filters.statuses.join(','),
        paymentMethods: filters.paymentMethod,
        firstName: filters.firstName,
        lastName: filters.lastName,
        limit: filters.itemsPerPage,
        page: filters.page,
      }

      return api.fetchPayments(filterParams)
          .then(response => {
            return response.data
          })
          .catch(err => {
            this.handleError(err)
          })
          .finally(() => this.isLoadingPayments = false)
    },

    async fetchClaims(val) {
      this.clearMessages()
      this.isLoadingClaims = true
      let nameParts = val.split(' ')
      let firstPart = nameParts.shift()
      let lastPart = nameParts.pop() || firstPart
      let filters = {
        firstName: firstPart,
        lastName: lastPart
      }
      return api.searchClaims(filters)
          .then(response => {
            this.claims = response.data.content
          })
          .catch(err => {
            this.handleError(err)
          })
          .finally(() => this.isLoadingClaims = false)
    },

    handleError: function (err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errorMessages.push(errorMessage)
    },

    processBulkAction: async function () {
      this.clearMessages()
      let payload = {
        status: this.bulkActionStatus.value,
        ids: this.bulkActionItems
      }

      return api.updateBulkPaymentStatuses(payload)
          .then(() => {
            this.bulkActionItems = []
            this.bulkActionStatus = null
            this.fetchPayments()
            this.successMessages.push('Payments statuses updated successfully.')
          })
          .catch(err => {
            this.handleError(err)
          })
    },

    async exportCsv() {
      this.clearMessages()
      const paymentData = await this.fetchPaymentsForExport()
      if (paymentData === undefined || paymentData === null) {
        this.errorMessages.push('Error generating export data')
        return
      }

      if (paymentData.page.totalElements === 0) {
        this.warningMessages.push("No payments matching your filters to export.")
        return
      }

      const exportData = [
        [
            'invoiceNumber',
            'receivedFrom',
            'description',
            'paymentDate',
            'amount',
            'paymentMethod',
            'referenceNumber',
            'status',
            'createdAt'
        ]
      ]

      paymentData.content.forEach((payment) => {
        let description
        const invoice = payment.invoice
        if (invoice !== undefined && invoice.items.length !== 0) {
          description = payment.invoice.items[0].description
        } else {
          description = 'Unknown payment item'
        }

        const row = [
            invoice.id,
            invoice.user.names,
            description,
            moment(payment.date).local().format('MM/DD/YYYY'),
            payment.amount,
            this.paymentMethodMap[payment.method],
            payment.reference,
            this.paymentStatusMap[payment.status],
            moment.utc(payment.created).local().format('MM/DD/YYYY HH:mm:ss')
        ]
        exportData.push(row)
      })

      exportUtils.exportCsvData(exportData, 'TilyetPaymentsExport.csv')
    },

  },

  data() {
    return {
      payments: [],
      errorMessages: [],
      warningMessages: [],
      successMessages: [],
      bulkActionStatus: null,
      bulkActionItems: [],
      bulkActionValid: false,
      filterPaymentStatus: null,
      filtersDialog: false,
      claims: [],
      filter: {
        claim: null,
        statuses: [],
        page: 1,
        itemsPerPage: 25,
      },
      searchResponse: {
        content: [],
        empty: true,
        page: {
          totalPages: 0,
        }
      },

      selectedClaims: [],
      claimSearchString: '',
      nativeClaimSearchString: '',
      isLoadingClaims: false,
      isLoadingPayments: false,

      paymentMethodMap: constants.getPaymentMethodMap(),
      paymentStatusMap: constants.getPaymentStatusMap(),
    }
  }
}
</script>


<style lang="sass">

th.payment-amount, th.payment-action
  width: 5%

tr.highlight-new-payment
  background-color: #F1F8E9

th.payment-invoice-num
  width: 8%

th.payment-date, th.payment-method, th.payment-reference
  width: 10%

</style>
